import React from "react";
import {
  MotifCard,
  MotifCardHeader,
  MotifCardBody,
  MotifBreadcrumb,
  MotifBreadcrumbItem,
} from "@ey-xd/motif-react";
import { useNavigate } from "react-router-dom";
import { getAccount } from "../../common/services/commonService";

import "./adminSettings.scss";

export const AdminSettings = React.memo(() => {
  const navigate = useNavigate();

  return (
    <>
      <div className="admin-settings-container">
        <div className="admin-settings-breadcrumb-wrap">
          <MotifBreadcrumb>
            <MotifBreadcrumbItem>
              <a
                href="/"
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/");
                }}
              >
                Home
              </a>
            </MotifBreadcrumbItem>
            <MotifBreadcrumbItem>Settings</MotifBreadcrumbItem>
          </MotifBreadcrumb>
        </div>
        <div className="card-wrapper">
          <MotifCard
            orientation="horizontal"
            variant="card-border"
            onClick={() => {
              navigate("#");
            }}
          >
            <MotifCardHeader>
              <div className="motif-card-subheader">
                <span className="motif-h6-default-regular">
                  <div className="imgConfig">
                    <img
                      loading="lazy"
                      alt=""
                      src={require("../../common/images/config-files.png")}
                    />
                  </div>
                  <div className="title-wrapper">
                    <div className="title">Config Files</div>
                  </div>
                </span>
              </div>
            </MotifCardHeader>
            <MotifCardBody>
              <span className="motif-body1-default-light">
                Configuration files to manage various features and settings for
                DBS.
              </span>
            </MotifCardBody>
          </MotifCard>

          <MotifCard
            orientation="horizontal"
            variant="card-border"
            onClick={() => {
              navigate("/settings/user");
            }}
          >
            <MotifCardHeader>
              <div className="motif-card-subheader">
                <span className="motif-h6-default-regular">
                  <div className="img manageUserBg" >
                    <img
                      alt=""
                      src={require("../../common/images/user-settings.png")}
                    />
                  </div>
                  <div className="title-wrapper">
                    <div className="title">Manage Users</div>
                  </div>
                </span>
              </div>
            </MotifCardHeader>
            <MotifCardBody>
              <span className="motif-body1-default-light">
                Manage Users and access of the DBS admins and end users.
              </span>
            </MotifCardBody>
          </MotifCard>

          <MotifCard
            orientation="horizontal"
            variant="card-border"
            onClick={() => {
              navigate("/settings/deployment-scheduler");
            }}
          >
            <MotifCardHeader>
              <div className="motif-card-subheader">
                <span className="motif-h6-default-regular">
                  <div className="img deploymentSchedulerBg">
                    <img
                      alt=""
                      src={require("../../common/images/Deployment-Scheduler-icon.svg").default}
                    />
                  </div>
                  <div className="title-wrapper">
                    <div className="title">Deployment Scheduler</div>
                  </div>
                </span>
              </div>
            </MotifCardHeader>
            <MotifCardBody>
              <span className="motif-body1-default-light">
                Manage planned deployment windows and maintenance periods for
                the DBS Submission Portal.
              </span>
            </MotifCardBody>
          </MotifCard>
        </div>
      </div>
    </>
  );
});
